import { ChangeDetectionStrategy, Component, OnInit, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MaterialsService } from '../../../../../services/materials.service';
import { MaterialDetailDto } from '@models/material-detail-dto.interface';

export interface MaterialDetailsPopupData {
  materialId: number;
  title: string | null;
}

@Component({
  selector: 'app-material-details-popup',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatProgressSpinnerModule],
  templateUrl: './material-details-popup.component.html',
  styleUrl: './material-details-popup.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MaterialDetailsPopupComponent implements OnInit {
  private readonly dialogRef = inject(MatDialogRef<MaterialDetailsPopupComponent>);
  protected readonly data = inject<MaterialDetailsPopupData>(MAT_DIALOG_DATA);
  private readonly materialsService = inject(MaterialsService);

  protected readonly material = signal<MaterialDetailDto | null>(null);
  protected readonly isLoading = signal(true);
  protected readonly loadError = signal<string | null>(null);

  ngOnInit(): void {
    this.materialsService.getMaterial(this.data.materialId).subscribe({
      next: material => {
        this.material.set(material);
        this.isLoading.set(false);
      },
      error: () => {
        this.loadError.set('Unable to load material details.');
        this.isLoading.set(false);
      },
    });
  }

  protected onClose(): void {
    this.dialogRef.close();
  }
}
